// Core
import React from "react"
import styled from "styled-components"

// General components
import Title from "../../../../../../components/Title"
import Paragraph from "../../../../../../components/Paragraph"

// Style
import size from "../../../../../../styles/size"

const Container = styled.div`
  width: 100%;
  margin-left: 12rem;

  p {
    margin-top: 3rem;
  }

  @media (max-width: ${size.laptop}) {
    margin-top: 6rem;
    margin-left: 0px;
  }
`

export default function CopyContainer() {
  return (
    <Container>
      <Title>Seja muito bem-vindo à família Oceano da Graça.</Title>

      <Paragraph>
        Como é bom fazer parte de uma família para chamar de minha.
      </Paragraph>

      <Paragraph>
        Uma família feita de pessoas reais que amam servindo e conectando
        pessoas a Jesus.
      </Paragraph>

      <Paragraph>
        Uma família para pertencer, viver e participar de transformações
        incríveis da realidade de vidas e da nossa comunidade.
      </Paragraph>
    </Container>
  )
}
